import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import NumbersBase, { NumbersBaseProps } from "@/components/ui/Form/Filters/components/Numbers/NumbersBase";

export interface NumberControlledProps extends NumbersBaseProps {
  control: Control;
}
const FilterNumberControlled: FC<NumberControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <NumbersBase field={field} fieldState={fieldState} {...rest} />;
};
export default FilterNumberControlled;
